import { Locale } from '@eneco/common/application';
import { fr } from 'date-fns/locale/fr';
import { nlBE } from 'date-fns/locale/nl-BE';


export const getDateLocale = (locale: Locale) => {
  switch (true) {
    case locale.includes('nl'):
      return nlBE;
    default:
      return fr;
  }
};
